/**
 * Takes a sentence, returns its first word.
 */
export const getFirstWord = (sentence: string) => sentence.split(' ').shift() ?? '';
